<template>
  <vf-dialog-layout class="text-center">
    <template #title>
      <span class="sr-only">
        {{ title }}
      </span>
    </template>
    <vf-logo class="mt-4 w-22 inline" />
    <h1 class="mt-4 title-1 ">
      {{ title }}
    </h1>
    <p class="mt-4 ws-pre-wrap">
      {{ replaceAll($t.locationConfirmationText, { country: $t.countries[expectedCountry] || expectedCountryName }) }}
    </p>
    <div class="mt-4 f-col gap-2 ">
      <vf-button class="w-full" :variant="stayInLocationVariant" @click="doStayInLocale">
        <span v-if="showCountries" class="flex items-center space-x-1">
          <span>{{ $t.countries[currentCountry] || currentCountryName }}</span>
          <base-picture height="12" :src="`/img/flags/${currentCountry}.svg`" width="18" />
        </span>
        <span v-else>
          {{ $t.locationConfirmationStay }}
        </span>
      </vf-button>
      <vf-button class="w-full" :variant="changeLocationVariant" @click="changeLocale">
        <span v-if="showCountries" class="flex items-center space-x-1">
          <span>{{ $t.countries[expectedCountry] || expectedCountryName }}</span>
          <base-picture height="12" :src="`/img/flags/${expectedCountry}.svg`" width="18" />
        </span>
        <span v-else>
          {{ $t.locationConfirmationChange }}
        </span>
      </vf-button>
    </div>
  </vf-dialog-layout>
</template>

<script setup lang="ts">
import type { CountryCode } from '#types/locale'

const {
  currentCountryName,
  currentCountry,
  currentDomain = '',
  expectedCountry,
  expectedCountryName,
  link,
} = defineProps<Props>()

const emit = defineEmits<Emits>()

const {
  showCountries,
  stayInLocationVariant,
  changeLocationVariant
} = useAppConfig().components.dialog.locationConfirmation

export type Props = {
  currentCountry: Uppercase<CountryCode>
  currentCountryName?: string
  currentDomain?: string
  link: string
  expectedCountry: Uppercase<CountryCode>
  expectedCountryName: string
}

export type Emits = {
  resolve: []
}

const confirmedCountry = useLocalStorage<Uppercase<CountryCode>>('confirmedCountry', null)
const { $t } = useNuxtApp()

const title = computed(() => replaceAll(
  $t.locationConfirmationHeading,
  { country: $t.countries[currentCountry] || currentCountryName, domain: currentDomain }
))

const changeLocale = () => {
  confirmedCountry.value = expectedCountry
  window.location.href = link
}

const doStayInLocale = () => {
  confirmedCountry.value = useCountryCode()
  emit('resolve')
}
</script>
